import React from 'react';
import { workflowSourceLabel } from './WorkflowRefLink';

// ── 資料來源（provenance）的單一出處 ─────────────────────────────────────────
//
// 每筆 engagement／QC6-7／FS／QC35 記錄的 `source` 分三類（業主 2026-09-17）：
//   workflow:*  由流程核准產生（申請單號在 sourceRequestNo）
//   manual      在 Management 直接建立
//   import      系統匯入（匯入工具以服務帳號寫入）
// 清單不放 Source 欄；檢視頁表頭放一顆小標籤（ProvenanceBadge），歷程列印
// provenanceLabel。三面共用這裡，不各自翻譯。

export const provenanceOf = (source) => {
  const s = String(source || '').trim();
  if (s === 'import') return 'import';
  if (/^workflow:/i.test(s)) return 'workflow';
  return 'manual';
};

const META = {
  import: { label: 'Imported', cls: 'bg-violet-50 text-violet-700', title: 'Imported by the data-import tool' },
  manual: { label: 'Management', cls: 'bg-slate-100 text-slate-600', title: 'Created in Management' },
};

/**
 * Small chip for the detail-page header. Workflow-created rows render nothing
 * here — their request number (a link) already says where they came from.
 */
export const ProvenanceBadge = ({ source, className = '' }) => {
  const kind = provenanceOf(source);
  const meta = META[kind];
  if (!meta) return null;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${meta.cls} ${className}`}
      title={meta.title}
    >
      {meta.label}
    </span>
  );
};

/** The detail header's "· <origin>" phrase: imported / created in Management / null for workflow. */
export const provenanceOrigin = (source) => {
  const kind = provenanceOf(source);
  if (kind === 'import') return 'imported';
  if (kind === 'manual') return 'created in Management';
  return null;
};

/**
 * History rows: 'Import' / 'Management' / the flow's display name for
 * workflow:*; null for anything else (callers fall back to their own maps).
 */
export const provenanceLabel = (source) => {
  const s = String(source || '').trim();
  if (s === 'import') return 'Import';
  if (s === 'manual') return 'Management';
  return workflowSourceLabel(s);
};
